import axios from '../../axios/axios';

const API_URL = window.env?.BACKEND_ENDPOINT ? `${window.env.BACKEND_ENDPOINT}/auth/` : 'http://localhost:9090/api/auth/';

class AuthService {
  async login(username, password) {
    try {
      const response = await axios.post(API_URL + 'login', {
        username,
        password
      }, {
        withCredentials: true
      });
      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data));
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  logout() {
    return axios.post(API_URL + 'logout', {}, {
      withCredentials: true
    }).finally(() => {
      localStorage.removeItem('user');
    });
  }

  register(username, email, password, name, surname, dateOfBirth, phoneNumber) {
    return axios.post(API_URL + 'register', {
      username,
      email,
      password,
      name,
      surname,
      dateOfBirth,
      phoneNumber
    });
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    return null;
  }

  isAuthenticated() {
    return this.getCurrentUser() !== null;
  }

  hasRole(role) {
    const user = this.getCurrentUser();
    return user && user.role === role;
  }

  isAdmin() {
    return this.hasRole('ROLE_ADMIN');
  }
}

export default new AuthService();